import { Component, OnInit, TemplateRef} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationEvaluateService } from 'src/app/Service/Calibration/CalibrationEvaluate.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CalibrationEvaluateList',
  templateUrl: './CalibrationEvaluateList.component.html',
  styleUrls: ['./CalibrationEvaluateList.component.scss']
})
export class CalibrationEvaluateListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private CalibrationEvaluate_Service:CalibrationEvaluateService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_Evaluate:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1156).subscribe(
      data=>{
        this.ReadData_Evaluate()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Evaluate(){
    this.Procssing=true
    this.CalibrationEvaluate_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_Evaluate=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    this.Procssing=true
    this.modalRef_Delete.hide()
    this.CalibrationEvaluate_Service.DeleteCalibrationEvaluate(item.id,this.Token).subscribe(
      data => {
        this.Procssing = false
        if (data.id == -1)
          this.Alertify_Service.SuccessMessage("No more than 10 questions can be active.")
        else if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_Evaluate()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  Switcher_Form: string = 'List'
  Set_Add_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_General_Interface()
    this.Switcher_Form='Form'
  }

  Set_Edit_Switcher_Form(item:General_Interface) {
    this.Data_Seleted_Delete = item
    this.Switcher_Form='Form'
  }

  Set_Back_Switcher_Form() {
    this.Data_Seleted_Delete = Empty_General_Interface()
    this.Switcher_Form='List'
  }


}
